import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Circle, GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';
import './style.css';
import CustomMarker from '../../Atoms/CustomMarker';
import { calculateBearing } from '../../../Library/geodist';
import { GOOGLE_MAPS_API_KEY } from '../../../Library/constants';
import { getItemFromLocalStorage } from '../../../Library/helpers';
import { Button, Checkbox, Tooltip } from '@chakra-ui/react';
import { StoreContext } from '../../../Library/contexts';
import { TargetIcon, ZoomOutIcon } from '../../../Assets/images/svgs';

const GeofenceMarker = require('../../../Assets/images/pngs/GeofenceMarker.png');
const GEOFENCE_MARKER = { "url": GeofenceMarker };

const libraries = [ "places", "drawing" ];
const VehicleMap = ({ vids = [ ], vehMap = new Map(), allGeofences = [ ], updateVehiclesTable, showExistingGfsToggle = false, setShowExistingGeofences, showExistingGeofences, hideGeofenceMarkers, isStateFilterActive }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const [vehicleMap, setVehicleMap] = useState(new Map());
  const [ showInfoWindow, setShowInfoWindow ] = useState(false);
  const vehicleMapRef = useRef(new Map());
  const [ showVehicleZoom, setShowVehicleZoom ] = useState({});
  const [ isVehicleFocused, setIsVehicleFocused ] = useState(false);
  const initialMapBounds = useRef({});

  const mapRef = useRef(null);
  const isUser = useRef(getItemFromLocalStorage());
  const originalVehicleMap = useRef([]);
  const [mapCenter, setMapCenter] = useState({ lat: 23.2599, lng: 77.4126 });

  useEffect(() => {
    if (!Array.from(vehicleMap.values()).length || !Array.from(vehMap.values()).length) return;

    if (!originalVehicleMap.current || !originalVehicleMap.current.size) originalVehicleMap.current = new Map(vehicleMap);
    let newVehicleMap = new Map(vehicleMap);

    Array.from(originalVehicleMap.current.values()).forEach(vehicle => {
      let vehicleValue = vehMap.get(vehicle.vid);
      if (!vehicleValue || !vehicleValue.idx) newVehicleMap.delete(vehicle.vid)
      else {
        let newVehicleMapValue = newVehicleMap.get(vehicle.vid)
        if (!newVehicleMapValue || !newVehicleMapValue.vid) newVehicleMap.set(vehicle.vid, originalVehicleMap.current.get(vehicle.vid));
      }
    });

    setVehicleMap(newVehicleMap);
    vehicleMapRef.current = newVehicleMap;
  }, [ vehMap ]);

  useEffect(() => {
    let vehicles = Array.from(vehMap.values());
    if (isStateFilterActive && vehicles && vehicles.length) {
      var bounds = new window.google.maps.LatLngBounds();
      vehicles.forEach(vehicle => {
        if (!vehicle.ping) vehicle.ping = vehicleMapRef.current.get(vehicle.idx);
        if (vehicle.ping && vehicle.ping.lat && vehicle.ping.lng) {
          var latLng = new window.google.maps.LatLng(parseFloat(vehicle.ping.lat, 10), parseFloat(vehicle.ping.lng, 10));
          bounds.extend(latLng);
        }
      });

      if (mapRef.current) {
        mapRef.current.fitBounds(bounds);
        let newCenter = bounds.getCenter();

        var centerLatLng = new window.google.maps.LatLng(parseFloat(newCenter.lat(), 10), parseFloat(newCenter.lng(), 10));
        mapRef.current.setCenter(centerLatLng);
      }
    }

  }, [ isStateFilterActive, vehMap ]);

  const handleVehicleZoom = (veh) => {
    setShowVehicleZoom(veh)
  }

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.VEHICLE_INFO_SHOWN, handleVehicleZoom);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.VEHICLE_INFO_SHOWN, handleVehicleZoom);
    }
  }, [])

  const onLoad = (map) => {
    mapRef.current = map;
    initListeners();
  };

  const handleLastSeen = useCallback((data) => {
    if (!mapRef.current) return;

    let totalLat = 0;
    let totalLng = 0;

    data.forEach((vehicle) => {
      totalLat += vehicle.lat;
      totalLng += vehicle.lng;
      addUpdateValueInVehicleMap(vehicle.vid, vehicle);
    });

    var bounds = new window.google.maps.LatLngBounds();
    let lastSeenVehMap = new Map(vehicleMap);
    data.forEach((item) => {
      if (item && item.lat && item.lng) {
        var latLng = new window.google.maps.LatLng(parseFloat(item.lat, 10), parseFloat(item.lng, 10));
        if (latLng) bounds.extend(latLng);

        if (data.length > 1) {
          mapRef.current.initialZoom = true;
          mapRef.current.fitBounds(bounds);
          initialMapBounds.current = bounds;
        }
      }

      lastSeenVehMap.set(item.vid, item);
    });

    setVehicleMap(lastSeenVehMap);
    vehicleMapRef.current = lastSeenVehMap;
    updateVehiclesTable(lastSeenVehMap);

    if (data.length > 1) {
      window.google.maps.event.addListener(mapRef.current, 'zoom_changed', function() {
        let zoomChangeBoundsListener =
          window.google.maps.event.addListener(mapRef.current, 'bounds_changed', function() {
            if (mapRef.current.getZoom() > 15 && mapRef.current.initialZoom === true) {
                mapRef.current.setZoom(16);
                mapRef.current.initialZoom = false;
            }
            window.google.maps.event.removeListener(zoomChangeBoundsListener);
        });
      });
    }

    if (totalLat && totalLng) {
      let centerLat = totalLat / data.length;
      let centerLng = totalLng / data.length;
      let center = { lat: centerLat, lng: centerLng };

      setMapCenter(center);
    }

    let action = global.EE.EVENT_TYPES.SUBSCRIBE_TO_VEHICLES;
    let vehicles = { veh: vids };
    global.WS.sendRequest({ action, data: vehicles });
  }, [ vids ]);

  const updateVehicleMap = useCallback((data) => {
    if (data && data.vid) {
      setVehicleMap((oldVehicleMap) => {
        let vehicle = oldVehicleMap.get(data.vid);
        if (!vehicle) return oldVehicleMap;

        let newVehicleMap = new Map(oldVehicleMap);
        if(data.ignition && data.spd >= 5) {
          if(!data.brg) data.direction = calculateBearing(vehicle.lat, vehicle.lng, data.lat, data.lng);
          else data.direction = data.brg;
        }
        newVehicleMap.set(vehicle.vid, data);
        if (vehicle.heartbeat) newVehicleMap.set("heartbeat", vehicle.heartbeat);

        if (vids.length === 1 && data.lat && data.lng) {
          var latLng = new window.google.maps.LatLng(parseFloat(data.lat, 10), parseFloat(data.lng, 10));
          mapRef.current.setCenter(latLng);
          mapRef.current.setZoom(16);
        }

        updateVehiclesTable(newVehicleMap);
        return newVehicleMap;
      });
    }
  }, [ vids ]);

  const initListeners = useCallback(() => {
    if (!global.WS.wsConnected) {
      const onWsConnected = () => {
        global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
        initListeners();
      }

      global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
      return;
    }

    // Add Listeners for Last Seen and Pings
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_LAST_SEEN, handleLastSeen);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RT_LOC_EVT, updateVehicleMap);

    // Subscribe to Given VIDs
    let action =  isUser.current ? "getDynamicLastSeen" : "getLastSeen";
    let data = { vids: vids };
    global.WS.sendRequest({ action, data });

  }, [ vids, handleLastSeen, updateVehicleMap ]);

  const onWsConnected = () =>{
    if(mapRef.current && vids.length){
      let action = global.EE.EVENT_TYPES.SUBSCRIBE_TO_VEHICLES;
      let vehicles = { veh: vids };
      global.WS.sendRequest({ action, data: vehicles });
    }
  };

  useEffect(()=>{
    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
    return () =>{
    global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
    };
  }, [])


  useEffect(() => {
    return () => {
      // Remove Listeners for Last Seen and Pings

      global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_LAST_SEEN, handleLastSeen);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.RT_LOC_EVT, updateVehicleMap);

      if (!global.WS.wsConnected) return;

      // Unsubscribe if VIDs Change
      const action = global.EE.EVENT_TYPES.UNSUBSCRIBE_TO_VEHICLES;
      const vehicles = { veh: vids };
      global.WS.sendRequest({ action, data: vehicles });
    };
  }, []);


  const addUpdateValueInVehicleMap = (key, value) => {
    setVehicleMap((prevMap) => new Map(prevMap.set(key, value)));
  };

  const onZoomChanged = () => {
    if (vehicleMap.size === 1) {
      vehicleMap.forEach((vehicle) => {
        if (!vehicle) return;

        var latLng = new window.google.maps.LatLng(parseFloat(vehicle.lat, 10), parseFloat(vehicle.lng, 10));
        mapRef.current.setCenter(latLng);
      });
    }

    if (vehicleMap.size > 1) {
      var bounds = new window.google.maps.LatLngBounds();
      vehicleMap.forEach((vehicle) => {
        if (vehicle && vehicle.lat && vehicle.lng) {
          var latLng = new window.google.maps.LatLng(parseFloat(vehicle.lat, 10), parseFloat(vehicle.lng, 10));
          if (latLng) bounds.extend(latLng);
        }
      });

      if (showVehicleZoom && !showVehicleZoom.vid) mapRef.current.setCenter(bounds.getCenter());
    }
  };

  const handleVehicleZoomIn = () => {
    if (isVehicleFocused) {
      mapRef.current.fitBounds(initialMapBounds.current);
      setIsVehicleFocused(false);
      return;
    }

    var bounds = new window.google.maps.LatLngBounds();
    var latLng = new window.google.maps.LatLng(parseFloat(showVehicleZoom.lat, 10), parseFloat(showVehicleZoom.lng, 10));
    bounds.extend(latLng);
    mapRef.current.fitBounds(bounds);

    setIsVehicleFocused(true);
  }

  return (
    <div className="vehicle-maps">
      {isLoaded ? (
        <GoogleMap
          mapContainerClassName={`map-container ${vehicleMap.size ? "" : "hide-map"}`}
          center={mapCenter}
          zoom={14}
          onLoad={onLoad}
          onZoomChanged={onZoomChanged}
          onClick={() => setShowInfoWindow(false)}
          options={{ gestureHandling: "cooperative", streetViewControl: false }}
        >
          {showExistingGfsToggle ? <div className="geofences-toggle-btn">
            <Checkbox onChange={(e) => setShowExistingGeofences(e.target.checked)} checked={showExistingGeofences} className="view-existing-geofences">
              View Geofences
            </Checkbox>
          </div> : null}

          {(showVehicleZoom && showVehicleZoom.vid && vehicleMap.size > 1) ? <Tooltip label={isVehicleFocused ? "Zoom Out" : "Zoom In"}>
            <Button className={`focus-vehicle-btn ${isVehicleFocused ? " add-padding" : ""}`} onClick={handleVehicleZoomIn}>
              {isVehicleFocused ? <ZoomOutIcon /> : <TargetIcon />}
            </Button>
          </Tooltip> : null}

          {Array.from(vehicleMap.values()).map((vehicle, idx) => {
            if (!vehicle || !vehicle.vid || !vehicle.lat) return "";
            return <CustomMarker
              key={idx}
              vehicle={vehicle}
              vehicleInfo={vehMap.get(vehicle.vid)}
              onInfoWindowClose={() => setShowVehicleZoom(false)}
            />
          })}

          { showExistingGeofences ? allGeofences.map((geofence, idx) => (
            <React.Fragment key={idx}>
              <Circle
                radius={geofence.r}
                center={{ lat: geofence.clat, lng: geofence.clong }}
                editable={false}
                options={{ fillColor: "#00A8E270", strokeWeight: 2, strokeColor: "#00A8E2", strokeOpacity: 0.8, }}
                zIndex={1}
                onClick={() => setShowInfoWindow({ idx: geofence.idx })}
              />
              {showInfoWindow.idx === geofence.idx ? <InfoWindow onCloseClick={() => setShowInfoWindow(false)} options={{ pixelOffset: new window.google.maps.Size( 0, -30 ) }} position={{ lat: geofence.clat, lng: geofence.clong }}>
                <div className="geofence-info-box">{ geofence.title }</div>
              </InfoWindow> : null}
              {hideGeofenceMarkers ? null : <Marker position={{ lat: geofence.clat, lng: geofence.clong }} icon={{ ...GEOFENCE_MARKER, scaledSize: new window.google.maps.Size(30, 40), scale: 1 }} ></Marker>}
            </React.Fragment>
          )) : null}
        </GoogleMap>
      ) : null}
      <p className="map-loading">Waiting for data...</p>

      {/* <div className="scroll-overlay"></div> */}
    </div>
  );
};

export default VehicleMap;
